export default "__VITE_ASSET__MJkx3Y6G__"